export enum Article {
  Author = 'Евгений Покалюк',
}
